// extracted by mini-css-extract-plugin
export default {"pitpass-map-marker":"dynamic-map__pitpass-map-marker___2fTZD"};